export default {
  title: 'Promo-Code-Details',
  back: 'Zurück zu Promo-Codes',
  tabs: {
    customers: 'Kunden',
    orders: 'Bestellungen',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Durchschn. Bestellwert',
    customer_adoption: 'Einzelne Kunden',
  },
  toasts: {
    failed_to_load_stats: 'Statistiken konnten nicht geladen werden',
  },
};
